"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkItemPillSection = void 0;
const work_flag_helpers_1 = require("@App/helpers/work-entities/utils/work-flag-helpers");
require("./index.scss");
const react_1 = __importDefault(require("react"));
const StatusPill_1 = __importDefault(require("@Components/StatusPills/StatusPill"));
const is_hold_status_1 = require("@App/helpers/work-entities/utils/is-hold-status");
const HoldStatusIndicator_1 = __importDefault(require("@Components//StatusPills/HoldStatusIndicator"));
const PublicDomainToolTip_1 = __importDefault(require("@Components/WorkItemPillSection/PublicDomainToolTip"));
const NonMusicalToolTip_1 = __importDefault(require("@Components/WorkItemPillSection/NonMusicalToolTip"));
const OverclaimStatusIndicator_1 = __importDefault(require("@Components/StatusPills/OverclaimStatusIndicator"));
const WorkItemPillSection = (props) => {
    const { work, showOverclaimStatus } = props;
    const onHold = (0, is_hold_status_1.isWorkOnHold)(work);
    const isPublicDomain = (0, work_flag_helpers_1.isWorkPublicDomain)(work);
    const isNonMusical = (0, work_flag_helpers_1.isNonMusicalWork)(work);
    return (react_1.default.createElement("div", { className: 'status-container' },
        onHold && work.holdTypeId && !showOverclaimStatus && react_1.default.createElement(HoldStatusIndicator_1.default, { holdStatus: work.holdTypeId }),
        work.overclaimStatusFilter && showOverclaimStatus && (react_1.default.createElement(OverclaimStatusIndicator_1.default, { overclaimStatus: work.overclaimStatusFilter })),
        isPublicDomain && react_1.default.createElement(StatusPill_1.default, { color: 'blue', tooltip: react_1.default.createElement(PublicDomainToolTip_1.default, null) }),
        isNonMusical && react_1.default.createElement(StatusPill_1.default, { color: 'blue', tooltip: react_1.default.createElement(NonMusicalToolTip_1.default, null) }),
        !work.isComplete && !work.overclaimHeaderId && react_1.default.createElement(StatusPill_1.default, { text: 'Draft', color: 'blue' })));
};
exports.WorkItemPillSection = WorkItemPillSection;
